import { render, staticRenderFns } from "./CompanyEmployeesInput.vue?vue&type=template&id=0f464132"
import script from "./CompanyEmployeesInput.vue?vue&type=script&lang=js"
export * from "./CompanyEmployeesInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports